import { generalClasses, selectInput, FORM_WIDTH } from '../subscriptor/styles';

export const MaintainerList = theme => ({
  card: {
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: '0'
    }
  },
  cardContent: {
    [theme.breakpoints.down('xs')]: {
      padding: '0'
    }
  }
});

export const editionMaintainer = theme => ({
  ...selectInput(theme),
  ...generalClasses(theme),
  formSubscriptor: {
    display: 'flex',
    flexDirection: 'column'
  },
  collapseContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  card: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  media: {
    height: 0,
    paddingTop: '56.25%' // 16:9
  },
  actions: {
    display: 'flex',
    flexDirection: 'row-reverse',
    padding: '20px 0px 20px 24px',
    alignSelf: 'center',
    width: FORM_WIDTH,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  message: {
    padding: '0px 5px'
  },
  withoutContainer: {
    boxShadow: '0px 0px 0px 0px transparent',
    background: 'transparent',
    height: '500px',
    justifyContent: 'center'
  },
  loginActions: {
    width: '600px',
    position: 'absolute',
    top: '400px',
    justifyContent: 'center',
    padding: '20px 0px 20px 0px'
  },
  [theme.breakpoints.down('xs')]: {}
});

export const maintainerForm = theme => {
  const classes = {
    ...selectInput(theme),
    ...generalClasses(theme),
    errorSimilarMessages: {
      fontSize: '10px'
    },
    loginCard: {
      alignSelf: 'center',
      width: '600px',
      height: '275px',
      overflow: 'inherit',
      margin: '15px 0px 15px 0px',
      '& > div:nth-child(2)': {
        paddingBottom: '0px'
      },
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      }
    }
  };
  classes.fullWidth['& label'] = {
    paddingLeft: '40px'
  };
  classes.fullWidth['& > div > div > label'] = {
    paddingLeft: '0px'
  };

  return classes;
};
